export default "__VITE_ASSET__DKC99mel__"